/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wd_Go_LiveInputs */

const en_wd_go_live = /** @type {(inputs: Wd_Go_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Live`)
};

const ar_wd_go_live = /** @type {(inputs: Wd_Go_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تشغيل مباشر`)
};

const bn_wd_go_live = /** @type {(inputs: Wd_Go_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লাইভ দেখুন`)
};

const de_wd_go_live = /** @type {(inputs: Wd_Go_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live gehen`)
};

const es_wd_go_live = /** @type {(inputs: Wd_Go_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzar en vivo`)
};

const fr_wd_go_live = /** @type {(inputs: Wd_Go_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer au direct`)
};

const pt_wd_go_live = /** @type {(inputs: Wd_Go_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmitir ao vivo`)
};

const zh_wd_go_live = /** @type {(inputs: Wd_Go_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上线`)
};

const tr_wd_go_live = /** @type {(inputs: Wd_Go_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı Yayına Geçin`)
};

const ru_wd_go_live = /** @type {(inputs: Wd_Go_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В прямом эфире`)
};

const pl_wd_go_live = /** @type {(inputs: Wd_Go_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij transmisję na żywo`)
};

/**
* | output |
* | --- |
* | "Go Live" |
*
* @param {Wd_Go_LiveInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const wd_go_live = /** @type {((inputs?: Wd_Go_LiveInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_Go_LiveInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_wd_go_live(inputs)
	if (locale === "bn") return bn_wd_go_live(inputs)
	if (locale === "de") return de_wd_go_live(inputs)
	if (locale === "es") return es_wd_go_live(inputs)
	if (locale === "fr") return fr_wd_go_live(inputs)
	if (locale === "pt") return pt_wd_go_live(inputs)
	if (locale === "zh") return zh_wd_go_live(inputs)
	if (locale === "tr") return tr_wd_go_live(inputs)
	if (locale === "ru") return ru_wd_go_live(inputs)
	if (locale === "pl") return pl_wd_go_live(inputs)
	return en_wd_go_live(inputs)
});